import React from 'react';
import styles from './widget.module.css';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

const WidgetComponent = () => {
  const shouldRenderWidgetWrapperBackground = useSelector(state =>
    get(state, ['builder', 'config', 'general', 'others', 'enableAdPlaceholderBackground'], false)
  );
  return (
    <div
      data-test-id="widget"
      className={`${styles.wrapper}
    ${shouldRenderWidgetWrapperBackground ? styles.wrapperBackgroundEnabled : ''}`}
    >
      <div className={styles.customWidget}>Custom Code</div>
    </div>
  );
};

export default WidgetComponent;
